import { z } from 'zod';
import { useSearch } from '@tanstack/react-router';
import { useFormHook } from '@Hooks/index';
import { OnboardingFormFields } from '@Types/index';
import { useNavigationManager } from '@Router/useNavigationManager';
import { RoutesMap } from '@Router/router.types';
import { useBoundStore } from '@Store/useBoundStore';
import { routesModel } from '@Router/router.consts';

export const useResetPasswordRequestLogic = () => {
  const { navigateToNextPage, navigateToSpecificPage } = useNavigationManager();
  const { setEmail } = useBoundStore((state) => state.resetPasswordSlice);
  const { email: userEmail } = useBoundStore((state) => state.resetPasswordSlice);

  const searchParams = useSearch({ from: routesModel[RoutesMap.RESET_PASSWORD_REQUEST].path }) as {
    email?: string;
  };
  const email = userEmail || searchParams?.email || '';

  const formMethods = useFormHook({
    schemaTitle: 'reset-password-request',
    formSchema: z.object({
      [OnboardingFormFields.EMAIL]: z.string().email('Invalid email'),
    }),
    formDefaultValues: {
      [OnboardingFormFields.EMAIL]: email,
    },
  });

  const handleSubmit = () => {
    setEmail(formMethods.getValues(OnboardingFormFields.EMAIL));
    navigateToNextPage(RoutesMap.RESET_PASSWORD_REQUEST);
  };

  const handleBack = () => {
    navigateToSpecificPage(RoutesMap.WELCOME);
  };

  return {
    formMethods,
    handleSubmit,
    handleBack,
  };
};
